import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SharedUtilCommonModule } from 'libs/shared/util-common/src/lib/util-common.module';
import { RichTextViewComponent } from 'shared/feature-rich-text-view';

import { GuidelineActionDto } from '@treetop/shared/model';

@Component({
  selector: 'tt-node-detail-popover-medications',
  standalone: true,
  templateUrl: './node-detail-popover-medications.component.html',
  styleUrl: './node-detail-popover-medications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedUtilCommonModule, RichTextViewComponent],
})
export class NodeDetailPopoverMedicationsComponent {
  @Input() medications: GuidelineActionDto[];
}
